import React from 'react'
import AppRoutes from './AppRoutes'


export default function ContentBody() {

    return (

        <div >
          
            <AppRoutes />

        </div>

    )
}
